import {
	createFileRoute,
	Outlet,
	useParams,
	useRouterState,
} from "@tanstack/react-router";
import { AssetWorkspaceRecordsTable } from "@/features/assets/components/asset-workspace-records-table";
import { isNestedRecordUnderOrgAssetWorkspacePath } from "@/features/assets/lib/get-org-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records",
)({
	component: OrgAssetWorkspaceRecordsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Org Asset workspace Records tab — table shell with outlet for record drawer /
 * nested workspace.
 */
function OrgAssetWorkspaceRecordsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records",
	});
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	if (isNestedRecordUnderOrgAssetWorkspacePath(pathname)) {
		return <Outlet />;
	}

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<AssetWorkspaceRecordsTable
				orgId={params.orgId}
				assetId={params.assetId}
				host="org"
			/>
			<Outlet />
		</div>
	);
}
